<script>
import { mapState } from 'vuex';
import Vue from 'vue';
import { cloneDeep } from 'lodash-es';

export default {
  name: 'SkiPersonCategory',
  props: {
    category: {
      type: Object,
      required: true,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      personCategoryItem: cloneDeep(this.category),
    };
  },
  computed: {
    ...mapState({
      selectedDomainId: state => state.ski.selectedDomainId,
    }),
  },
  watch: {
    category: {
      deep: true,
      handler() {
        this.personCategoryItem = cloneDeep(this.category);
      },
    },
    selectedDomainId() {
      this.setupDomains();
    },
  },
  methods: {
    onPersonCategoryChange(params) {
      this.$emit('onPersonCategoryChange', {
        personCategoryItem: this.personCategoryItem,
        params,
      });
      if (params.ageFrom) {
        this.$nextTick(() => {
          const element = 'ageFrom'.concat(this.personCategoryItem.ageFrom);
          this.$refs[element].focus();
        });
      }
    },
    setupDomains() {
      if (this.selectedDomainId !== null) {
        this.personCategoryItem.domains = this.personCategoryItem.domains || Vue.set(this.personCategoryItem, 'domains', {});
        if (!this.personCategoryItem.domains[this.selectedDomainId]) {
          Vue.set(this.personCategoryItem.domains, this.selectedDomainId, {
            domainId: this.selectedDomainId,
            name: '',
          });
        }
      }
    },
    created() {
      this.setupDomains();
    },
  },
};
</script>

<template>
  <v-container class="pa-0">
    <v-layout wrap>
      <v-flex class="text-xs-right pr-4 pt-3" sm1 xs12>
        <h3 :class="{'red--text': !personCategoryItem.id}">
          {{ personCategoryItem.id ? '#' + personCategoryItem.id : $t('buttons.new') }}
        </h3>
      </v-flex>
      <v-flex sm2 xs12>
        <v-text-field
          v-model="personCategoryItem.externalName"
          :placeholder="$t('ski.skiPersonCategory.nameSupplier')"
          :disabled="saveLoading"
          solo
        />
      </v-flex>
      <v-flex sm2 xs12>
        <v-text-field
          v-model="personCategoryItem.name"
          :disabled="saveLoading"
          placeholder="Global Name"
          solo
        />
      </v-flex>
      <v-flex sm2 xs12>
        <v-text-field
          v-if="selectedDomainId !== null"
          v-model="personCategoryItem.domains[selectedDomainId].name"
          :disabled="saveLoading"
          placeholder="Domain Name"
          solo
        />
      </v-flex>
      <v-flex sm1 xs12>
        <v-text-field
          v-model="personCategoryItem.ageFrom"
          :placeholder="$t('ski.skiPersonCategory.ageFrom')"
          :disabled="saveLoading"
          :ref="'ageFrom' + personCategoryItem.ageFrom"
          type="Number"
          max="99"
          min="0"
          solo
        />
      </v-flex>
      <v-flex sm1 xs12>
        <v-text-field
          v-model="personCategoryItem.ageTo"
          :placeholder="$t('ski.skiPersonCategory.ageTo')"
          :disabled="saveLoading"
          type="Number"
          max="99"
          min="0"
          solo
        />
      </v-flex>
      <v-flex sm1 xs12 class="pl-2 pt-0">
        <v-btn
          :disabled="saveLoading"
          class="mb-2"
          color="green"
          small
          outline
          @click="$emit('createOrUpdate', personCategoryItem)"
        >
          {{ category.id ? $t('buttons.save') : $t('buttons.create') }}
        </v-btn>
      </v-flex>
      <v-flex sm1 xs12 class="pl-4 pt-0">
        <v-btn
          :disabled="saveLoading"
          :color="category.id ? 'error' : 'warning'"
          class="mb-2"
          small
          outline
          @click="$emit('remove', category.id)"
        >
          {{ category.id ? $t('buttons.remove') : $t('buttons.cancel') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/ski/rental/SkiPersonCategory.vue